function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var SpeedMeter = function SpeedMeter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M12 1c6.065 0 11 4.935 11 11s-4.935 11-11 11S1 18.065 1 12 5.935 1 12 1m0 15.686a8.9 8.9 0 0 0-5.844 2.154A8.96 8.96 0 0 0 12 21c2.228 0 4.27-.814 5.844-2.16A8.9 8.9 0 0 0 12 16.686m0 .968a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M12 3c-4.962 0-9 4.037-9 9 0 2.017.666 3.88 1.79 5.382a11.05 11.05 0 0 1 6.58-2.678l2.4-4.818a1 1 0 0 1 1.791.891l-2.002 4.021c2.084.301 4.055 1.2 5.651 2.582A8.94 8.94 0 0 0 21 12c0-4.963-4.037-9-9-9m0 1c4.123 0 7.625 3.217 7.971 7.323a1 1 0 0 1-.912 1.08c-.545.069-1.034-.361-1.08-.912C17.718 8.413 15.091 6 12 6s-5.719 2.412-5.979 5.492a1 1 0 1 1-1.993-.168C4.375 7.218 7.876 4 12 4"
  }));
};
export default SpeedMeter;